import React, { FC } from 'react';

import { Navigate, Route, Routes } from 'react-router-dom';

import router from '~/core/router';
import AuthRoute from '~/route/AuthRoute';
import PrivateRoute from '~/route/PrivateRoute';
import UnAuthorizedRoute from '~/route/UnAuthorizedRoute';

import {
  ExtensionOffboardingOldPath,
  ExtensionOffboardingPath,
  ExtensionOnboardingOldPath,
  ExtensionOnboardingPath,
} from './modules/extension/constants';
import RouteHelmet from './route/RouteHelmet';

const authRoutes = router.getAuthRoutes();
const privateRoutes = router.getPrivateRoutes();
const unAuthorizedRoutes = router.getUnAuthorizedRoutes();

const redirects = [
  { from: ExtensionOnboardingOldPath, to: ExtensionOnboardingPath },
  { from: ExtensionOffboardingOldPath, to: ExtensionOffboardingPath },
];

const Router: FC = () => {
  return (
    <>
      <Routes>
        {authRoutes.map(({ path, Component }) => (
          <Route
            key={path}
            path={path}
            element={
              <RouteHelmet>
                <AuthRoute Component={Component} />
              </RouteHelmet>
            }
          />
        ))}
        {privateRoutes.map(({ path, Component, checkAvailability }) => (
          <Route
            key={path}
            path={path}
            element={
              <RouteHelmet key={path}>
                <PrivateRoute
                  Component={Component}
                  checkAvailability={checkAvailability}
                />
              </RouteHelmet>
            }
          />
        ))}
        {unAuthorizedRoutes.map(({ path, Component, checkAvailability }) => (
          <Route
            key={path}
            path={path}
            element={
              <RouteHelmet key={path}>
                <UnAuthorizedRoute
                  Component={Component}
                  checkAvailability={checkAvailability}
                />
              </RouteHelmet>
            }
          />
        ))}
        {redirects.map(({ from, to }) => (
          <Route key={from} path={from} element={<Navigate to={to} />} />
        ))}
        <Route
          path="*"
          element={<Navigate to={router.getSignInRoutePath()} />}
        />
      </Routes>
    </>
  );
};

export default Router;
